import { render, staticRenderFns } from "./innerMongolia_directory.vue?vue&type=template&id=6030461b&scoped=true&"
import script from "./innerMongolia_directory.vue?vue&type=script&lang=js&"
export * from "./innerMongolia_directory.vue?vue&type=script&lang=js&"
import style0 from "./innerMongolia_directory.vue?vue&type=style&index=0&id=6030461b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6030461b",
  null
  
)

export default component.exports